import { logout } from '@/awsCodes/awsUtils';
import { mystore } from '@/store';
/**
 *
 */
export const normalLogout = async () => {
  try {
    await logout();
  } catch (e) {}
  mystore.commit('loginStateModule/setUnAuthenticated');
  mystore.commit('loginStateModule/unsetAttributes');
  if (location.pathname !== '/login') {
    location.href = '/login';
  }
};
